<template>
    <div
        ref="searchBody"
        v-on-scrollto.bottom.20="handleScrollBottom"
        class="search-list"
        :class="[single ? 'is-single' : '']"
    >
        <v-tip
            ref="tip"
            placement="top"
        >
            <span>{{ $t('未设置软电话权限，请至管理-客户端添加。') }}</span>
        </v-tip>
        <v-spinner
            v-if="searching"
            status="default"
            class="searching"
        />
        <template v-else>
            <v-tree
                v-if="records.length"
                ref="tree"
                :maps="maps"
                :options="records"
                :selected="selected"
                :single="single"
                @change="selectedChange"
            >
                <template
                    slot="item"
                    slot-scope="props"
                >
                    <a
                        class="v-tree__title"
                        :class="{
                            'is-selected': props.selected,
                            'has-selected': props.options.selected
                        }"
                        @click="props.toggle"
                    >
                        <span class="v-tree__button v-tree__button--feature">
                            <v-icon :name="getItemIco(props.options)" />
                        </span>
                        <!-- eslint-disable vue/no-v-html -->
                        <span
                            class="v-tree__name"
                            :title="props.options.title"
                            v-html="props.options.hNameId"
                        >
                            <span v-if="props.options.account">({{ props.options.account }})</span>
                        </span>
                        <span
                            v-if="props.options.disabled"
                            v-tip:tip.hover
                            class="tips"
                        ><v-icon name="tips" /></span>
                    </a>
                </template>
            </v-tree>
            <div
                v-else
                class="search-list-empty"
            >
                {{ currentKeywords ? tip : '' }}
            </div>
            <div
                v-show="!noMoreData"
                class="search-list-more"
            >
                <v-spinner :class="showLoadMore ? '' : 'is-hidden'">
                    {{ $t('加载更多') }}
                </v-spinner>
            </div>
        </template>
    </div>
</template>

<script>
/* eslint-disable */
import { Icon as VIcon, Spinner as VSpinner, Tip as VTip, Tree as VTree, OnScrollto as onScrollto } from 'vhtml-ui';
import { strEntity } from '@tencent/qd-lib';

const req = require.context('./assets/icons', false, /[^\.]+\.svg$/);
VIcon.addSprites(req);

export default {
    name: 'SearchList',
    directives: {
        'on-scrollto': onScrollto
    },
    components: {
        VIcon,
        VTip,
        VTree,
        VSpinner
    },
    model: {
        prop: 'keywords',
        event: 'input'
    },
    props: {
        keywords: String,
        selected: Array,
        single: Boolean
    },
    data() {
        return {
            searching: true,
            loading: false,
            currentKeywords: this.keywords,
            noMoreData: false,
            showLoadMore: false,
            records: [],
            index: 0,
            count: 15,
            tip: this.$t('无搜索结果'),
            maps: {
                value: 'id'
            }
        };
    },
    watch: {
        keywords(val) {
            this.currentKeywords = val;
        }
    },
    methods: {
        selectedChange(sels, type) {
            sels = sels.map(item => {
                const newItem = { ...item };
                const regStart = new RegExp('<span class="highlight-keywords">', 'ig');
                const regEnd = new RegExp('</span>', 'ig');

                newItem.name = newItem.name.replace(regStart, '').replace(regEnd, '');

                return newItem;
            });

            this.$emit('change', sels, type);
        },
        handleScrollBottom() {
            if (this.noMoreData) {
                return;
            }
            this.showLoadMore = true;
            this.fetch(true);
        },
        fetch(touchBottom) {
            if (this.loading) {
                return;
            }

            if (!touchBottom) {
                this.searching = true;
                this.noMoreData = false;
                this.showLoadMore = false;
                this.records = [];
                this.index = 0;
            }

            this.loading = true;
            // let defer = this.$ajax.get('/call/settings/receptiongroup/users', {

            console.log('gavintest');
            const defer = this.$ajax.post('/mng/org/getUserTreeNodes', {
                keywords: this.currentKeywords,
                current_page: this.index,
                items_per_page: this.count
                // count: this.count,
                // index: this.index
            });

            this.index !== 0 && (this.showLoadMore = true);
            defer
                .then(res => {
                    console.log(res);
                    let records = res.list || [];
                    const len = records.length;
                    if (len === 0) {
                        this.tip = this.$t('无搜索结果');
                    }
                    if (len < this.count) {
                        this.noMoreData = true;
                    }

                    records = records.map(item => {
                        const newItem = { ...item };

                        if (this.currentKeywords !== '') {
                            const placeholder = '__KEYWORD__';
                            const reg = new RegExp(this.currentKeywords, 'ig');
                            const pReg = new RegExp(placeholder, 'g');
                            const str = `<span class="highlight-keywords">${this.currentKeywords}</span>`;
                            // 防止XSS攻击
                            newItem.name = strEntity
                                .encode(item.name.replace(reg, placeholder))
                                .replace(pReg, str);
                            const hid = strEntity.encode(item.id.replace(reg, placeholder)).replace(pReg, str);
                            newItem.hNameId = `${newItem.name}<span class="s-account">${hid}</span>`;
                            newItem.title = `${item.name} ${item.id}`;
                        }

                        return newItem;
                    });

                    this.records.push(...records);
                    this.index++;
                    this.showLoadMore = false;
                    this.searching = false;
                    this.loading = false;
                })
                .catch(res => {
                    this.$message.error(res.message || this.$t('获取数据失败'));
                    this.tip = this.$t('获取数据失败');
                    this.showLoadMore = false;
                    this.searching = false;
                    this.loading = false;
                });

            return defer;
        },

        getItemIco(opt) {
            console.log(opt);
            console.log(opt.selected);
            let icoName = '';

            if (opt.isFolder || opt.isParent) {
                icoName = 'department';
            } else if (opt.gender == 1) {
                icoName = 'male';
            } else {
                icoName = 'female';
            }

            if (opt.selected == 1) {
                icoName += '-selected';
            }

            return icoName;
        }
    }
};
</script>

<style lang="less">
.highlight-keywords {
    color: #64cc56;
}
.search-list {
    width: 278px;
    height: 349px;
    border: 1px solid #dadee7;
    margin-top: -1px;
    position: relative;
    overflow: auto;
    user-select: none;

    &.is-single {
        width: 398px;
        height: 374px;
    }

    &-empty {
        position: absolute;
        text-align: center;
        left: 0;
        top: 40%;
        width: 100%;
    }

    .searching {
        position: absolute;
        left: 50%;
        top: 40%;
        margin: -10px 0 0 -10px;
    }

    &-more {
        text-align: center;
        padding-bottom: 5px;
    }

    .is-hidden {
        visibility: hidden;
    }

    .v-tree {
        float: left;
        min-width: 100%;
    }

    .s-account {
        margin-left: 10px;
        color: #a8abb3;
    }

    .v-tree__title {
        padding-left: 15px;
    }
    .v-tree__button {
        vertical-align: 0;
    }
}
</style>
